import React, { useState, useEffect } from 'react';
import { OptionalState } from '../../utils/ReactHelper';
import Logger from '../../../common/utils/Logger';
import Carousel from 'react-bootstrap/Carousel';
import Image from 'react-bootstrap/Image';

import imgCover from '../images/cover3.jpg';
import Linker from '../../library/Linker';

type Props = {
    linker: Linker;
};

type State = {
};

const StateDefault: State = {
};

const HomeHeader = (props: Props) => {

    const [state, setState] = useState(StateDefault);

    const updateState = (updates: Partial<State>) => {
        setState(OptionalState(state, updates));
    };

    useEffect(() => {
        new Promise(async (resolve, reject) => {
            return Promise.resolve();
        });
    }, []);

    return (
        <>
            <Carousel className='text-center home-carousel' >
                <Carousel.Item>
                    <div className="home-image-container">
                        <Image src={imgCover} height={300} width={300}></Image>
                    </div> 
                    <Carousel.Caption>
                        <h3>First slide label</h3>
                        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <div className="home-image-container">
                        <Image src={imgCover} height={300} width={300}></Image>
                    </div> 
                    <Carousel.Caption>
                        <h3>Second slide label</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <div className="home-image-container">
                        <Image src={imgCover} height={300} width={300}></Image>
                    </div> 
                    <Carousel.Caption>
                        <h3>Third slide label</h3>
                        <p>
                            Praesent commodo cursus magna, vel scelerisque nisl consectetur.
                        </p>
                    </Carousel.Caption>
                </Carousel.Item>
            </Carousel>
        </>
    );
};

export default HomeHeader;